"use client";
import React, { useCallback, useEffect, useState } from "react";
import { Formik, Form } from "formik";
// import ReviewStar from "../ReviewStar/ReviewStar";
import { postReview } from "@/src/models/review";
// import Router from "@hoc/withRouterCore.js";
import { useCommonContext, useUserInfoContext } from "@/src/provider";
import {
    FmButton,
    FmDrawer,
    FmTextArea,
    FmToast,
    FmRating,
} from "@/ui-component";
import { getQuestion, openUploadStore } from "@/store";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import Upload from "@/src/components/Upload";
import stl from "./writeReviewForm.module.scss";
import classnames from "classnames";
import { useTranslation } from "@/src/i18n/client";
import WriteQuestionsForm from "@/src/components/WriteQuestionsForm";

interface IProps {
    productId: number |  undefined;
    type: 0 | 1; //1 -->评论， 0-->问题;
    open: boolean;
    setOpen?: (open: boolean) => void;

    // values: Record<string, any>; //包含 reviews_rating, reviews_photo,uploading
}
interface IValues {
    reviews_rating: number;
    reviews_text: string;
    reviews_photo: string;
    uploading: boolean;
    webp_url: string;
    tag: string;
}

const initialValues = {
    reviews_rating: 5,
    reviews_text: "",
    reviews_photo: "", //普通图片路劲
    uploading: false,
    webp_url: "", //webp图片路径
    tag: "",
};

const WriteReviewForm: React.FC<IProps> = (props) => {
    const { host } = useCommonContext();
    const { t } = useTranslation(["review", "common"]);

    const [toastVisible, setToastVisible] = useState(false);
    const [toastChildren, setToastChildren] = useState("");
    const [uploading, setUploading] = useState(false);
    const [customers_firstname] = useUserInfoContext((state) => [
        state.data.customers_firstname,
    ]);
    const [ isAns, closeUpload] = openUploadStore.useOpenUploadStore(
        (state) => [ state.isAns, state.closeUpload],
    );
    const [questions, getReviewQuestion] = getQuestion.useGetQuestionsStore(
        (state) => [state.questions, state.getReviewQuestion],
    );

    const [openStatus , setOpenStatus] = useState(false);
    useEffect(() => {
        setOpenStatus(props.open);
    }, [props.open]);


    function showToast(msg: string, seconds?: number, callback?: () => void) {
        if (!msg.length) {
            setToastVisible(false);
            return;
        }
        setToastChildren(msg);
        setToastVisible(true);
        // 触发回调关闭弹窗，调用回调
        callback &&
            seconds &&
            setTimeout(() => {
                setToastVisible(false);
                callback();
                changeOpen();
            }, seconds * 1000);
    }

    useEffect(() => {
        getReviewQuestion();
    }, [getReviewQuestion]);
    // const isSelected = (name) => {
    //     let tags = document.getElementsByName(name);
    //     let select = [];
    //     for (let i in tags) {
    //         if (tags[i].checked) {
    //             if (tags[i].name == "recommend") {
    //                 select.push(i == 0 ? "1" : "2");
    //             } else {
    //                 select.push(tags[i].value);
    //             }
    //         }
    //     }
    //     return select.toString().replace(/,/g, ";");
    // };
    const suggestion = (name: any) => {
        let tags = document.getElementsByName(name);
        return (tags[0] as any).checked ? "31" : "";
    };

    const handleSubmit = useCallback(
        async (
            values: IValues,
            { setSubmitting, setFieldValue, setTouched }: any,
        ) => {
            const data: Record<string, any> = {
                ...values,
                comment_name: customers_firstname ?? "",
                products_id: props.productId,
                reviews_type: isAns ? 0 : 1,
            };
            if (isAns) delete data.reviews_rating;
            if (values.uploading) {
                showToast(t("review:plsWaitUploading"));
                setSubmitting(false);
                return;
            }
            // 非登录状态似乎进不来这里
            // if (!isLogin()) {
            //     const backUrl = Router.asPath;
            //     showToast(
            //         t("common:PLES_LOGIN_FIRST"),
            //         2,
            //         () =>
            //             (location.href = `/login${backUrl ? "?url=" + backUrl : ""}`),
            //     );
            //     setSubmitting(false);
            //     return;
            // }
            try {
                const res = await postReview(data);

                showToast(res.msg, 3, closeUpload);

                setSubmitting(false);
                setFieldValue({
                    reviews_rating: 5,
                    reviews_text: "",
                    reviews_photo: "",
                    uploading: false,
                });
                typeof setTouched === "function" && setTouched();
            } catch (e: any) {
                showToast(e?.message || e?.msg || t("common:Failed"));
                setSubmitting(false);
            }
        },
        [closeUpload, customers_firstname, isAns, props.productId, t],
    );

    const { type } = props;
    const changeOpen = () => {
        props.setOpen?.(false);
        setOpenStatus(false);
        closeUpload()
    }
    return (
        <>
            <FmToast
                visible={toastVisible}
                onChange={(visible) => setToastVisible(visible)}
                seconds={3}
            >
                {toastChildren}
            </FmToast>
            <FmDrawer
                open={openStatus}
                onClose={changeOpen}
                closeable
                className={stl["write-review-form-container"]}
                headerClassName={stl["header-container"]}
                headerChildren={<span style={{fontSize: '16px'}}>{t(`review:${isAns ? "ASK_LIST" : "Reviews"}`)}</span>}
                closeablePosition="right"
                // fullHeight
                headerFooter={true}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validate={(values) => {
                        const errors: Record<string, any> = {};
                        if (!values.reviews_text) {
                            errors.reviews_text = "Required";
                        }
                        return errors;
                    }}
                >
                    {({ values, setFieldValue, errors, isSubmitting }) => (
                        <Form
                            action=""
                            method="post"
                            className={stl["write-review-container"]}
                            style={{ padding: '0 0 20px 0' }}
                        >
                            <div
                                className={
                                    stl["product-review-alert-container"]
                                }
                            >
                                {!isAns && questions.length !== 0 && (
                                    <div className={stl["write-review-border"]}>
                                        <div
                                            className={classnames(
                                                stl["write-review-title"],
                                                stl["title-margin"],
                                            )}
                                        >
                                            {t(
                                                "review:FirmooNeedFeedBack",
                                            ).replace(
                                                "%siteName%",
                                                getSiteConfiguration(
                                                    "siteName",
                                                    host,
                                                ),
                                            )}
                                        </div>
                                    </div>
                                )}

                                {!isAns && (
                                    <div className={stl["write-review-border"]}>
                                        <div
                                            className={stl["review-star-input"]}
                                        >
                                            <span
                                                className={
                                                    stl["write-review-rating"]
                                                }
                                            >
                                                {t("Rating") + ":"}
                                            </span>
                                            {values.reviews_rating && (
                                                <FmRating
                                                    value={
                                                        values.reviews_rating
                                                    }
                                                    name="reviews_rating"
                                                    onChange={(e, star) =>
                                                        setFieldValue(
                                                            "reviews_rating",
                                                            star,
                                                        )
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className={stl["write-review-border"]}>
                                    {isAns && (
                                        <div
                                            className={classnames(
                                                stl["write-review-title"],
                                                stl["title-margin"],
                                            )}
                                            style={{ margin: "0 0 .2rem" }}
                                        >
                                            {t("review:ASK_QUESTION")}
                                        </div>
                                    )}

                                    {!isAns && questions.length !== 0 && (
                                        <div
                                            className={classnames(
                                                stl["write-review-title"],
                                                stl["title-margin"],
                                            )}
                                        >
                                            {t(
                                                "review:HowDoesThisFrameLookOnYou",
                                            )}
                                        </div>
                                    )}

                                    {!isAns && (
                                        <p
                                            className={
                                                stl["title-margin-suggestion"]
                                            }
                                        >
                                            <label
                                                className={classnames(
                                                    stl["label-width"],
                                                    stl[" iCheckboxInput"],
                                                )}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="31"
                                                    value=""
                                                    onChange={(e) => {
                                                        const isSelected =
                                                            suggestion("31");
                                                        setFieldValue(
                                                            "tag",
                                                            isSelected,
                                                        );
                                                    }}
                                                />
                                                <span
                                                    className={
                                                        stl["iCheckboxSpan"]
                                                    }
                                                    style={{
                                                        margin: "0 .1rem 0 0",
                                                        height: ".25rem",
                                                        width: ".25rem",
                                                        transform:
                                                            "translateY(-2px)",
                                                        padding: "2px",
                                                    }}
                                                ></span>
                                                {
                                                    "Tick here if your review includes suggestions for other customers."
                                                }
                                            </label>
                                        </p>
                                    )}
                                    <FmTextArea
                                        className={classnames(
                                            stl["review-text-input"],
                                            {
                                                [stl["input-error"]]:
                                                    errors.reviews_text,
                                            },
                                        )}
                                        error={!!errors.reviews_text}
                                        helperText={errors.reviews_text}
                                        onChange={(e) => {
                                            setFieldValue(
                                                "reviews_text",
                                                e.target.value,
                                                true,
                                            );
                                        }}
                                        defaultValue={values.reviews_text}
                                        placeholder={t(
                                            isAns
                                                ? "review:AskQuestionsSpecificToTheProduct"
                                                : "review:ReviewInputPlaceHolder",
                                        )}
                                        name="reviews_text"
                                        id=""
                                        InputProps={{
                                            classes: {
                                                root: stl["input-props-root"],
                                            },
                                        }}
                                        FormHelperTextProps={{
                                            classes: {
                                                error: stl[
                                                    "input-form-help-text-error"
                                                ],
                                            },
                                        }}
                                        // cols="30"
                                        rows="5"
                                    ></FmTextArea>
                                </div>

                                {!isAns && (
                                    <div className={stl["write-review-border"]}>
                                        <WriteQuestionsForm
                                            setFieldValue={setFieldValue}
                                            values={values}
                                            // change={(url) => {
                                            //     setValues({ ...values, ...url });
                                            // }}
                                        />
                                    </div>
                                )}

                                <div className={stl["write-review-border"]}>
                                    <p className={stl["review-update-photo"]}>
                                        {t("review:UploadYourPhotos")}
                                    </p>
                                    <Upload
                                        //评论图片需要上传普通图片，webp图片
                                        upWebp={type == 1}
                                        change={(imgUrl, webp_url) => {
                                            setFieldValue(
                                                "reviews_photo",
                                                imgUrl,
                                            );
                                            setFieldValue("webp_url", webp_url);
                                        }}
                                        uploading={uploading}
                                        changeUploading={(v) => setUploading(v)}
                                        halfUrl={true}
                                    />
                                </div>
                                <FmButton
                                    className={stl["review-update-btn"]}
                                    type="submit"
                                    disabled={isSubmitting}
                                    fullWidth
                                    buttonColor={"#000"}
                                >
                                    {t(
                                        isAns
                                            ? "common:btn.submit"
                                            : "review:Comment",
                                    )}
                                </FmButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </FmDrawer>
        </>
    );
};

export default WriteReviewForm;
